import {ReactElement, useState, RefObject} from 'react'
import {Trans} from 'react-i18next'

import {ReactComponent as UploadIcon} from '../../../../../../../../assets/images/arrow_up_from_box.svg'
import messages from '../../../../../../../../assets/messages'
import {isValidFile, ALLOWED_FILE_TYPES} from './utils'
import {useStyles} from './styles'

type UploadFileAreaProps = {
  fileInputRef: RefObject<HTMLInputElement>,
  onUpload: (file: File) => void
}

function UploadFileArea(props: UploadFileAreaProps): ReactElement {
  const {fileInputRef, onUpload} = props
  const classes = useStyles()
  const [error, setError] = useState<null | string>(null)

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0]

      if (!isValidFile(file)) {
        setError('Invalid file')
        return
      }

      setError(null)
      onUpload(file)
    }
  }

  const handleDragOver = (e) => e.preventDefault()

  const handleDrop = (e) => {
    e.preventDefault()
    if (e.dataTransfer.items && e.dataTransfer.items.length) {
      const item = e.dataTransfer.items[0]
      const file = item.getAsFile()
      if (!isValidFile(file)) {
        setError('Invalid file')
        return
      }

      setError(null)
      onUpload(file)
    }
  }

  const handleContainerClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <div className={classes.container} onClick={handleContainerClick} onDrop={handleDrop} onDragOver={handleDragOver}>
      <UploadIcon />
      <div className={classes.title}>
        <Trans {...messages.dragAndDropUploadFile} />
      </div>
      <div className={classes.titleRemark}>
        <Trans {...messages.dragAndDropUploadFileRemark} />
      </div>
      <div className={classes.titleValidation}>
        <Trans {...messages.dragAndDropUploadFileValidationType} />
      </div>
      <div className={classes.titleValidation}>
        <Trans {...messages.dragAndDropUploadFileValidationSize} />
      </div>
      {error ? <div className={classes.error}>{error}</div> : null}
      <input
        accept={ALLOWED_FILE_TYPES.join(',')}
        className={classes.input}
        type="file"
        multiple={false}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
    </div>
  )
}

export {UploadFileArea}
